import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { fmtEUR } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

const stockLabel = { in: "Në stok", low: "Pak në stok", out: "Nuk ka në stok", backorder: "Me porosi" };
const stockColor = { in: "bg-emerald-600", low: "bg-orange-500", out: "bg-red-600", backorder: "bg-blue-600" };

export default function ProductCard({ p, compact }) {
  const { addToCart } = useApp();
  const status = p.stock_status || "in";
  const img = p.images?.[0] || "https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=500";
  const add = (e) => {
    e.preventDefault();
    addToCart({ product_id: p.id, name: p.name, quantity: 1, unit_price: p.discount_price || p.price, vat_rate: p.vat_rate ?? 18, image: img });
    toast.success("U shtua në shportë");
  };
  return (
    <Link to={`/produkt/${p.id}`} data-testid={`product-card-${p.id}`}
      className={`hg-product-card block ${compact ? "w-52 flex-shrink-0" : ""}`}>
      <div className="relative aspect-square bg-white overflow-hidden">
        <img src={img} alt={p.name} className="w-full h-full object-contain" loading="lazy" />
        <span className={`absolute top-2 left-2 ${p.badge_text ? "bg-[#FFD600] text-black" : `${stockColor[status]} text-white`} text-[10px] uppercase tracking-wider px-2 py-1 flex items-center gap-1 font-bold`}>
          {!p.badge_text && <span className="w-1.5 h-1.5 rounded-full bg-white/90" />}
          {p.badge_text || stockLabel[status]}
        </span>
      </div>
      <div className="p-3 flex flex-col gap-2">
        <div className="text-xs uppercase text-neutral-500 tracking-wider">{p.brand}</div>
        <div className="text-sm font-medium line-clamp-2 min-h-[40px] text-[#0F1B33]">{p.name}</div>
        <div className="flex items-end justify-between mt-1">
          <div className="text-green-600 font-black text-xl">{fmtEUR(p.discount_price || p.price)}</div>
          <button onClick={add} disabled={status === "out"} data-testid={`add-cart-${p.id}`}
            className="w-9 h-9 flex items-center justify-center bg-[#FFD600] text-black disabled:opacity-40 hover:bg-yellow-300 transition-colors rounded">
            <ShoppingCart size={16} />
          </button>
        </div>
      </div>
    </Link>
  );
}
